import {Injectable} from '@angular/core';

export interface Toast {
  type: string,
  message: string
}

@Injectable({providedIn: 'root'})
export class ToastService {
  toasts: Toast[] = [];

  success(message: string) {
    this.toasts.push({type: 'SUCCESS', message: message});
  }

  failure(message: string) {
    this.toasts.push({type: 'FAILURE', message: message});
  }

  remove(toast: Toast) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  clear() {
    this.toasts.splice(0, this.toasts.length);
  }
}
